import {get, patch, post} from '@/services/infrastructure/api.service'
import {ref} from 'vue'
import emitter, {useEmitter} from '@/services/infrastructure/emitter'
import {LOGOUT, NO_ORG_SELECTED, ORG_SELECTED, ORG_SWITCHED} from '@/types/events'
import {find} from 'lodash'
import {TRANSACTION_CREATED} from '@/types/transaction/TransactionEvent'
import {findDefaultVatOption, useVatService} from '@/vat/vat.service'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const BOOKKEEPING_ACCOUNT = '/bookkeeping-account'

const {onEvents} = useEmitter()

const bookkeepingAccounts = ref<BookkeepingAccount[]>([])

const intervalSearch = (bookkeepingAccountEntries: BookkeepingAccount[], searchText: string) => {
    const [start, end] = searchText.split('-')

    if (start && end) {
        return bookkeepingAccountEntries.filter(account => {
            const accountNo = account.accountNo
            return (
                accountNo >= start &&
                accountNo <= end)
        })
    }
}

const {vatOptions} = useVatService()

const defaultBookkeepingAccount = (): BookkeepingAccount => {
    return {
        accountNo: '',
        name: '',
        description: '',
        vatSuggestionId: findDefaultVatOption(vatOptions.value)?.id ?? 1,
        keywords: [],
        active: true,
        isAccrual: false
    }
}

//TODO: Name: Should reflect that this is used to update existing account also
const upsertBookkeepingAccount = async (cmd: BookkeepingAccount) => {
    return await post(BOOKKEEPING_ACCOUNT, {
        ...cmd
    })
}

const updateMultipleAccountActiveStatus = async (accounts: Array<string>, active: boolean) => {
    return await patch(BOOKKEEPING_ACCOUNT, {
        accounts,
        active
    })
}

const getBookeepingAccounts = async (tenantId?: string): Promise<BookkeepingAccount[]> => {
    return await get(BOOKKEEPING_ACCOUNT, {}, tenantId) ?? []
}

//TODO: Naming: Should be plural
const fetchBookkeepingAccount = async () => {
    try {
        bookkeepingAccounts.value = await getBookeepingAccounts()
    } catch (e: any) {
        //     TODO add error message
    }
}

const findAccountByNo = (accountNo: string) => {
    return find(bookkeepingAccounts.value, {accountNo: accountNo}) as BookkeepingAccount
}

let initialized = false
const init = () => {
    if (initialized) return
    initialized = true
    fetchBookkeepingAccount()
        .catch(err => {
            console.error('Error fetching booking account', err)
        })
}

const clear = () => {
    bookkeepingAccounts.value = []
}

const BOOKKEEPING_ACCOUNT_CREATED = 'bookkeepingAccountCreated'

onEvents([ORG_SWITCHED, TRANSACTION_CREATED, BOOKKEEPING_ACCOUNT_CREATED], fetchBookkeepingAccount)
emitter.on(ORG_SELECTED, init)
emitter.on(NO_ORG_SELECTED, clear)
emitter.on(LOGOUT, clear)

export {
    bookkeepingAccounts,
    upsertBookkeepingAccount,
    getBookeepingAccounts,
    fetchBookkeepingAccount,
    updateMultipleAccountActiveStatus,
    defaultBookkeepingAccount,
    findAccountByNo,
    intervalSearch,
}